import { cn } from '@lib/utils/helpers'
import { getOrgTabs } from '../../constants/editPage'
import type { OrganizationEditSectionProps } from '../../types/components'

export function OrganizationEditTabBar({ ctx }: OrganizationEditSectionProps) {
  const tabs = getOrgTabs(ctx.orgId)

  return (
    <div className="flex min-w-0 flex-col border-b border-slate-200 sm:flex-row sm:items-stretch">
      <div
        className="grid min-w-0 flex-1"
        style={{ gridTemplateColumns: `repeat(${tabs.length}, minmax(0, 1fr))` }}
        role="tablist"
        aria-label="Organization sections"
      >
        {tabs.map((tab) => (
          <button
            key={tab.id}
            type="button"
            className={cn(
              '-mb-px min-h-[2.75rem] border-b-2 px-1 py-2 text-center text-[10px] font-semibold leading-tight transition-colors sm:min-h-0 sm:px-2 sm:py-3 sm:text-xs md:text-sm',
              'whitespace-normal break-words text-balance',
              ctx.selectedTab === tab.id
                ? 'border-blue-600 text-blue-600'
                : 'border-transparent text-slate-500 hover:text-slate-800',
            )}
            onClick={() => ctx.setSelectedTab(tab.id)}
            role="tab"
            aria-selected={ctx.selectedTab === tab.id}
            id={`org-tab-${tab.id}`}
            aria-controls={`org-panel-${tab.id}`}
          >
            {tab.label}
          </button>
        ))}
      </div>
    </div>
  )
}
